var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.model.title != null
    ? _c(
        "div",
        { staticClass: "registration" },
        [
          _c("vue-title", { attrs: { title: _vm.model.title } }),
          _vm._v(" "),
          _c("h1", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.model.title))
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateBeforeSubmit.apply(null, arguments)
                }
              }
            },
            [
              _vm.model.showError
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "validation-summary-errors alert alert-danger fade show",
                        attrs: {
                          role: "alert",
                          "data-valmsg-summary": "true",
                          "data-test-element": "idp-alert-danger-generic"
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("warning")
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.model.errorMessage))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          type: "button",
                          name: "Action:RedirectToLogin",
                          disabled: _vm.disabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.loginCancel(_vm.cancelLink)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("shared:action:back")))]
                    )
                  ])
                : _c("div", [
                    _c("fieldset", [
                      _c("div", {
                        staticClass: "panel-message",
                        domProps: { innerHTML: _vm._s(_vm.model.instructions) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: { "mb-4": _vm.model.isAddNewPhoneEnabled } },
                        [
                          _c("label", [
                            _c("span", { staticClass: "item label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:login:setupOTPSelectPhone"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.model.availablePhoneNumbers, function(
                            option,
                            index
                          ) {
                            return _c("div", { staticClass: "form-group" }, [
                              _c("input", {
                                staticClass: "mr-1",
                                attrs: {
                                  type: "radio",
                                  name: "phoneNumber",
                                  id:
                                    parseInt(option.countryCodeID) > 1
                                      ? option.countryCodeID
                                      : "1",
                                  "data-id": option.countryCode,
                                  "data-pid": option.id,
                                  "data-forsms": option.registeredForSMS
                                },
                                domProps: {
                                  value: option.phoneNumber,
                                  checked: index == 0
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.ddlBindPhoneNumber()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "displayInline",
                                  attrs: { for: option.id }
                                },
                                [
                                  _vm._v(
                                    " +" +
                                      _vm._s(option.countryCode) +
                                      " " +
                                      _vm._s(option.phoneNumber)
                                  )
                                ]
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _vm.model.isAddNewPhoneEnabled &&
                          _vm.model.phoneComplexity !== null
                            ? _c("div", [
                                _c("input", {
                                  staticClass: "mr-1",
                                  attrs: {
                                    type: "radio",
                                    id: "addnewradio",
                                    name: "phoneNumber"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.txtBindPhoneNumber()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "control countryCode displayInline",
                                    attrs: {
                                      id: "ddlCountryCode",
                                      disabled: ""
                                    }
                                  },
                                  _vm._l(_vm.model.countries, function(
                                    country
                                  ) {
                                    return _c("option", {
                                      attrs: { "data-id": country.countryCode },
                                      domProps: {
                                        value: country.countryCodeID,
                                        innerHTML: _vm._s(
                                          _vm.returnCountryCodeAndCountryName(
                                            country.countryCode,
                                            country.countryName
                                          )
                                        )
                                      }
                                    })
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.insertmodel.phoneNumber,
                                      expression: "insertmodel.phoneNumber"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        regex:
                                          _vm.model.phoneComplexity
                                            .phonePattern,
                                        min:
                                          _vm.model.phoneComplexity
                                            .phoneMinimumLength,
                                        max:
                                          _vm.model.phoneComplexity
                                            .phoneMaximumLength
                                      },
                                      expression:
                                        "{ required: true, regex: model.phoneComplexity.phonePattern, min: model.phoneComplexity.phoneMinimumLength, max: model.phoneComplexity.phoneMaximumLength }"
                                    }
                                  ],
                                  staticClass:
                                    "control input-text displayInline",
                                  class: {
                                    "input-validation-error": _vm.hasErrorOn(
                                      "phoneNo"
                                    )
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "txtPhoneNumber",
                                    name: "phoneNo",
                                    disabled: "",
                                    placeholder: "XXX XXX-XXXX",
                                    autocomplete: "off",
                                    maxlength: 15
                                  },
                                  domProps: {
                                    value: _vm.insertmodel.phoneNumber
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.insertmodel,
                                        "phoneNumber",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.hasErrorOn("phoneNo"),
                                        expression: "hasErrorOn('phoneNo')"
                                      }
                                    ],
                                    staticClass: "field-validation-error"
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("phoneNo")))]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-panel-row" }, [
                        _c("label", [
                          _c("span", { staticClass: "item label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "identityProvider:login:setupOTPpreferredNotificationMethod"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "displayInline" }, [
                            _c("input", {
                              staticClass: "mr-1",
                              attrs: {
                                type: "radio",
                                name: "preferredNotificationMethod",
                                id: "smsPerferredNotifyMethod",
                                value: "sms",
                                checked: "checked"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:login:setupOTPReceiveText"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "displayInline" }, [
                            _c("input", {
                              staticClass: "mr-1",
                              attrs: {
                                type: "radio",
                                name: "preferredNotificationMethod",
                                id: "callPerferredNotifyMethod",
                                value: "ivr"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:login:setupOTPReceiveCall"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            attrs: { type: "submit", disabled: _vm.disabled }
                          },
                          [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "button-secondary contextual-link",
                            attrs: {
                              "data-test-element": "security-question-cancel"
                            },
                            on: {
                              click: function($event) {
                                return _vm.loginCancel(_vm.cancelLink)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
                        )
                      ])
                    ])
                  ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49e048ee", { render: render, staticRenderFns: staticRenderFns })
  }
}